module.exports = __webpack_public_path__ + "static/media/ubr.6f19b197.png";